export enum CompanySelectorEvents {
  SELECTION_CHANGED = 'selectionChanged',
  ON_NEW_INPUT_STRING = 'onNewInputString',
  AVAILABLE_COMPANIES_UPDATED = 'availableCompaniesUpdated',
  SELECT_COMPANY = 'selectCompany',
}
